export default __webpack_public_path__ + "static/media/icons-metaverses-roblox.04d1934e.svg";